import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';


export function formatPrice(number) {
    return new Intl.NumberFormat('en-US').format(number);
}

export function formatDate(date, format = 'MMMM D, YYYY') {
    return moment(date).format(format);
}

export function timeAgo(date) {
    return moment(date).fromNow();
}


export function getDeviceToken() {
    if (typeof window === 'undefined') return ''; // SSR safety
    
    let token = localStorage.getItem('deviceToken');
    
    if (!token) {
        token = uuidv4();
        localStorage.setItem('deviceToken', token);
    }
    return token;
};
